import script from "./TradePassportGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./TradePassportGallery.vue?vue&type=script&setup=true&lang=js"

import "./TradePassportGallery.vue?vue&type=style&index=0&id=127d0798&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-127d0798"]])

export default __exports__